import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Users, GraduationCap, UserCheck, FileText, BookOpen, Megaphone } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [recentApps, setRecentApps] = useState([]);

  useEffect(() => {
    api.get('/admin/dashboard').then(r => setStats(r.data)).catch(() => {});
    api.get('/admissions/applications?status=submitted').then(r => setRecentApps(r.data.slice(0, 5))).catch(() => {});
  }, []);

  const metrics = stats ? [
    { label: 'Students', value: stats.students, icon: GraduationCap, color: 'text-sky-600 bg-sky-50', link: '/admin/students' },
    { label: 'Teachers', value: stats.teachers, icon: Users, color: 'text-emerald-600 bg-emerald-50', link: '/admin/teachers' },
    { label: 'Parents', value: stats.parents, icon: UserCheck, color: 'text-amber-600 bg-amber-50', link: '/admin/parents' },
    { label: 'Pending Applications', value: stats.pending_applications, icon: FileText, color: 'text-violet-600 bg-violet-50', link: '/admin/admissions' },
    { label: 'Active Classes', value: stats.classes, icon: BookOpen, color: 'text-rose-600 bg-rose-50', link: '/admin/classes' },
    { label: 'Announcements', value: stats.announcements, icon: Megaphone, color: 'text-indigo-600 bg-indigo-50', link: '/admin/announcements' },
  ] : [];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-[#1B2A4A]">Admin Dashboard</h1>
        <p className="text-slate-500 text-sm mt-1">Overview of your school management system</p>
      </div>

      {/* Metrics Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-8">
        {metrics.map(m => (
          <Link to={m.link} key={m.label}>
            <div className="stat-card flex items-center gap-4" data-testid={`stat-${m.label.toLowerCase().replace(/\s+/g, '-')}`}>
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${m.color}`}>
                <m.icon className="w-6 h-6" />
              </div>
              <div>
                <p className="text-2xl font-black text-[#1B2A4A]">{m.value}</p>
                <p className="text-sm text-slate-500 font-medium">{m.label}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* Recent Applications */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg text-[#1B2A4A]">Recent Pending Applications</CardTitle>
        </CardHeader>
        <CardContent>
          {recentApps.length === 0 ? (
            <p className="text-sm text-slate-400 py-4">No pending applications</p>
          ) : (
            <div className="space-y-3">
              {recentApps.map(app => (
                <div key={app.id} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                  <div>
                    <p className="text-sm font-semibold text-[#1B2A4A]">{app.child_first_name} {app.child_last_name}</p>
                    <p className="text-xs text-slate-500">{app.division} - {app.grade} | Ref: {app.reference_number}</p>
                  </div>
                  <span className="status-submitted text-xs px-2 py-1 rounded-full font-semibold">{app.status}</span>
                </div>
              ))}
              <Link to="/admin/admissions" className="text-sm font-semibold text-[#C9A84C] hover:underline block mt-2">
                View all applications &rarr;
              </Link>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
